export enum TaskStatus {
  'PLANNED' = 'PLANNED',
  'IN_PROGRESS' = 'IN_PROGRESS',
  'WAITING' = 'WAITING',
  'ON_HOLD' = 'ON_HOLD',
  'CANCELED' = 'CANCELED',
  'DONE' = 'DONE',
}

export enum TaskStatusClass {
  'PLANNED' = 'warning',
  'IN_PROGRESS' = 'success',
  'WAITING' = 'info',
  'ON_HOLD' = 'danger',
  'CANCELED' = 'dark',
  'DONE' = 'primary',
}

// Using new design library theme colors: 'primary', 'secondary', 'tertiary', 'danger', 'warning', 'success', or 'neutral'

export enum TaskStatusColor {
  'PLANNED' = 'warning',
  'IN_PROGRESS' = 'tertiary',
  'WAITING' = 'secondary',
  'ON_HOLD' = 'danger',
  'CANCELED' = 'neutral',
  'DONE' = 'primary',
}
